import { tint } from 'polished';

import {
  DefaultStyledProps,
  SUPPORTED_COMPONENTS,
  SUPPORTED_PROPERTIES,
} from '@savgroup-front-common/types';

import { getCustomComponentProperty } from '../../../helpers';

interface GetColorProps extends DefaultStyledProps {
  $info: boolean;
  $success: boolean;
  $alert: boolean;
  $error: boolean;
  $componentThemeName?: string;
}

interface GetTabBlockPaddingProps extends DefaultStyledProps {
  $componentThemeName?: string;
}

export const getTabBlockPadding = ({
  theme,
  $componentThemeName,
}: GetTabBlockPaddingProps): string | undefined => {
  const fallback = getCustomComponentProperty({
    theme,
    componentName: SUPPORTED_COMPONENTS.DEFAULT_BUTTONS,
    property: SUPPORTED_PROPERTIES.PADDING,
  });

  return getCustomComponentProperty({
    theme,
    componentName: $componentThemeName,
    property: SUPPORTED_PROPERTIES.PADDING,
    fallback,
  });
};

export const getColor = ({
  theme,
  $info,
  $success,
  $alert,
  $error,
  $componentThemeName,
}: GetColorProps): string => {
  if ($componentThemeName) {
    return (
      getCustomComponentProperty({
        theme,
        componentName: $componentThemeName,
        property: SUPPORTED_PROPERTIES.COLOR,
      }) || theme.colors.primary
    );
  }
  if ($info) {
    return theme.colors.primary;
  }
  if ($success) {
    return theme.colors.success;
  }
  if ($alert) {
    return theme.colors.alert;
  }
  if ($error) {
    return theme.colors.danger;
  }

  return theme.colors.primary;
};

export const getHoverColor = ({
  theme,
  $info,
  $success,
  $alert,
  $error,
  $componentThemeName,
}: GetColorProps): string => {
  const themeValue = getCustomComponentProperty({
    theme,
    componentName: $componentThemeName,
    property: SUPPORTED_PROPERTIES.ON_HOVER_COLOR,
  });

  if (themeValue) {
    return themeValue;
  }

  return tint(
    0.7,
    getColor({
      theme,
      $info,
      $success,
      $alert,
      $error,
    }),
  );
};
